import React, { useEffect, useState } from "react";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import { useMutation, useQuery } from "react-query";
import Axios from "axios";
import ContentValidation from "../../../components/common/ContentValidation";
import { SelectInput, TextInput } from "../../../components/globals";
import TableFilterBox from "../../../components/common/TableFilterBox";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../../helpers/FunctionsGlobal";
import useFetch from "../../../hooks/useFetch";
import { useChecked } from "../../../hooks";
import { MdOutlineChevronLeft } from "react-icons/md";
import { Checkbox, Dropdown } from "antd";
import { generateParams, labelTranslates } from "../../../utils/filtering";
import TableColumnProduct from "../../../components/Products/Items/TableColumnProduct";
import { antdMessageError } from "../../../helpers/Utils";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../helpers/AsyncMessage";

const initialPreviewByIdFilters = {
  title_cont: "",
  attrs_raw_cont: "",
  import_errors_null: "",
};

const fetcher = async ({ queryKey }) => {
  const [key, { product_import_id, filterStr }] = queryKey;
  const response = await Axios.get(
    `/api/v1/${key}/${product_import_id}?${filterStr}`
  );
  return response.data;
};

const ProductMassImportById = ({ product_import, onClose }) => {
  const { value: suppliers } = useFetch(
    "/api/v1/suppliers",
    {},
    [],
    (value) => {
      return value.data.map(({ name }) => ({
        value: name,
        label: name,
      }));
    }
  );

  const { onChangeChecked, checkedIncluded, checkedAll, setChecked, checked } =
    useChecked([]);

  const [filters, setFilters] = useState(initialPreviewByIdFilters);
  const [filterStr, setFilterStr] = useState("");
  const [openProducts, setOpenProducts] = useState([]);
  console.log(filters, "filters");
  console.log(filterStr, "filterStr");
  const {
    isLoading,
    error,
    data: { data = [] } = {},
    refetch,
  } = useQuery({
    queryKey: [
      "product_imports",
      { product_import_id: product_import.id, filterStr },
    ],
    queryFn: fetcher,
  });

  const mutationImportToPim = useMutation({
    mutationFn: (ids) => {
      antdAsyncMessageLoading({
        key: "mutationImportToPim",
        text: "Importing products to PIM",
      });
      return Axios({
        url: `/api/v1/product_imports/import_to_pim`,
        method: "POST",
        data: {
          ids,
        },
      }).then((res) => res.data);
    },
    onSuccess: () => {
      refetch();
      antdAsyncMessageSuccess({
        key: "mutationImportToPim",
      });
      // onClose(null);
    },
    onError: (error) => {
      antdAsyncMessageError({
        key: "mutationImportToPim",
        text: error?.response?.data?.message,
      });
    },
  });

  const handleToggle = (value) => {
    const currentIndex = openProducts.indexOf(value);
    const newChecked = [...openProducts];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setOpenProducts(newChecked);
  };

  const onChangeSelectState = (setState) => (name, value) => {
    const newValue =
      value === "true" ? true : value === "false" ? false : value;
    return setState((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  return (
    <>
      <ContentBlock>
        <FilterMenu
          totals={data.length}
          length={data.length}
          text2="Products"
        />
      </ContentBlock>
      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            if (generateParams(filters) == filterStr) {
              return refetch();
            }
            setFilterStr(generateParams(filters));
          }}
          add={false}
          clearFilter={() => setFilters(initialPreviewByIdFilters)}
          button1={
            <Dropdown
              arrow={true}
              trigger="click"
              menu={{
                items: [
                  {
                    key: "1",
                    label: (
                      <div
                        onClick={() => {
                          if (!checked.length)
                            return antdMessageError("Not selected");
                          mutationImportToPim.mutate(checked);
                        }}
                      >
                        Import selected
                      </div>
                    ),
                  },
                ],
              }}
              placement="bottomRight"
            >
              <button
                className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
                type="button"
              >
                Import to PIM
              </button>
            </Dropdown>
          }
        >
          <div className="row col-12">
            <div
              className="d-flex font-medium px-1 mr-2 cursor-pointer"
              onClick={onClose}
            >
              <div
                className="rounded-pill d-flex align-items-center justify-content-center mr-2 mb-1"
                style={{
                  backgroundColor: "#E6E6E6",
                  width: 22,
                  height: 22,
                }}
              >
                <MdOutlineChevronLeft />
              </div>
              {product_import.asset?.name}
            </div>
          </div>
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              {Object.entries(filters).map(([key, value]) => {
                if (key === "import_errors_null") {
                  const options = [
                    {
                      label: "All",
                      value: "",
                    },
                    {
                      label: "Yes",
                      value: "false",
                    },
                    {
                      label: "No",
                      value: "true",
                    },
                  ];
                  const selectedOption = options.find(
                    (option) => option.value === value
                  );

                  console.log(key, value?.toString());
                  return (
                    <div className="px-1" key={key}>
                      <SelectInput
                        label={labelTranslates[key]}
                        name={key}
                        value={selectedOption}
                        style={{ width: 165 }}
                        onChange={(e) => {
                          onChangeSelectState(setFilters)(key, e);
                          setFilterStr(generateParams(filters));
                        }}
                        options={options}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div className="px-1" key={key}>
                      <TextInput
                        text={labelTranslates[key]?.replace(
                          "First or last name",
                          "Title"
                        )}
                        style={{ width: 165 }}
                        name={key}
                        value={value}
                        onKeyDown={handleKeyDown2(() => {
                          if (generateParams(filters) == filterStr) {
                            return refetch();
                          }
                          setFilterStr(generateParams(filters));
                        })}
                        onChange={onChangeUseState(setFilters)}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </TableFilterBox>
        <ContentValidation loader={isLoading} array={data} error={error}>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <table className="table mt-3">
              <thead>
                <tr className="text-muted">
                  <th className="text-black">
                    <Checkbox
                      checked={checkedAll(
                        data
                          .filter(({ imported }) => !imported)
                          .map(({ id }) => id)
                      )}
                      onChange={() =>
                        setChecked(
                          checkedAll(
                            data
                              .filter(({ imported }) => !imported)
                              .map(({ id }) => id)
                          )
                            ? []
                            : data
                                .filter(({ imported }) => !imported)
                                .map(({ id }) => id)
                        )
                      }
                    />
                  </th>
                  <th className="text-black">Title</th>
                  <th className="text-black">Suppliers</th>
                  <th className="text-black">Quantity</th>
                  <th className="text-black">Department</th>
                  <th className="text-black">Supplier code</th>
                  <th className="text-black">Supplier price</th>
                  <th className="text-black">E-price</th>
                  {/* <th className="text-black">R-price</th> */}
                  <th className="text-black">Cost-price + PVM</th>
                  <th className="text-black">Import errors</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  return (
                    <TableColumnProduct
                      key={item.id}
                      suppliers={[]}
                      index={index}
                      item={item}
                      handleToggle={handleToggle}
                      openArray={openProducts}
                      checkedIncluded={checkedIncluded(item.id)}
                      onChangeChecked={() => onChangeChecked(item.id)}
                      isMassImport={true}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </ContentValidation>
      </ContentBlock>
    </>
  );
};

export default ProductMassImportById;
